import { languageToUrl } from './languageUtils';

/**
 * Get the localized public site domain based on the current language
 */
export const getPublicSiteDomain = () => {
  const langMap = {
    en: 'https://www.hubspot.com',
    de: 'https://www.hubspot.de',
    es: 'https://www.hubspot.es',
    pt: 'https://br.hubspot.com',
    fr: 'https://www.hubspot.fr',
    ja: 'https://www.hubspot.jp'
  };
  return languageToUrl(langMap);
};

/**
 * Get the localized partner program URL
 */
export const getPartnerProgramUrl = () => {
  const publicSiteDomain = getPublicSiteDomain();
  return `${publicSiteDomain}/partners/solutions`;
};